import { render, staticRenderFns } from "./Transaction.vue?vue&type=template&id=d060f732&scoped=true&"
import script from "./Transaction.vue?vue&type=script&lang=ts&"
export * from "./Transaction.vue?vue&type=script&lang=ts&"
import style0 from "./Transaction.vue?vue&type=style&index=0&id=d060f732&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d060f732",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
